import { render, staticRenderFns } from "./ImageUploadSlot.vue?vue&type=template&id=9b8c4e46&"
import script from "./ImageUploadSlot.vue?vue&type=script&lang=ts&"
export * from "./ImageUploadSlot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports